// This function disables the unwanted auto-scrolling behavior
function disableMediaScrollOnVariantChange() {
  // Select all media items related to product variants
  const mediaItems = document.querySelectorAll('.product__media-item');

  // Loop through each media item to set up a mutation observer
  mediaItems.forEach(item => {
    // MutationObserver watches for DOM changes (in this case: class changes)
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        // We're only interested in class attribute changes
        if (mutation.attributeName === 'class') {
          // Check if this item just became the active one
          const isNowActive = item.classList.contains('is-active');

          if (isNowActive) {
            /**
             * When a new variant is selected, Shopify themes (like Dawn)
             * often update which product media is "active" by toggling this class.
             * The theme JavaScript may also call `scrollIntoView()` on the new media,
             * causing a scroll jump — especially if the image is lower down.
             *
             * We prevent that by overriding the scrollIntoView function
             * on the element with a no-op (do-nothing) function.
             */
            item.scrollIntoView = () => {};
          }
        }
      });
    });

    // Start observing the item for changes to its attributes (like `class`)
    observer.observe(item, { attributes: true });
  });
}

// Once the DOM is fully loaded, run the scroll-disabling function
document.addEventListener('DOMContentLoaded', disableMediaScrollOnVariantChange);
